import { render, staticRenderFns } from "./demoDeliveryDestinationList.vue?vue&type=template&id=06e9b0ea&"
import script from "./demoDeliveryDestinationList.vue?vue&type=script&lang=ts&"
export * from "./demoDeliveryDestinationList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports